let animateDelay = 600;
let animateDuration = 600;
let scrollTop = 0;

function before_enter(el) {
  scrollTop = $(window).scrollTop();
  $(el).css({
    zIndex: 99,
    opacity: 0,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  });
  $(window).scrollTop(0);
}

function enter(el, done) {
  $(el)
    .velocity("stop")
    .velocity("fadeIn", {
      duration: animateDuration,
      display: $(el).css("display"),
      complete: done,
      delay: animateDelay,
    });
}

function after_enter(el) {
  el.removeAttribute("style");
}

function before_leave(el) {
  $(el).css({
    opacity: 1,
    zIndex: 1,
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    marginTop: scrollTop * -1,
  });
}

function leave(el, done) {
  $(el)
    .velocity("stop")
    .velocity("fadeOut", {
      duration: animateDuration,
      easing: "easeInCubic",
      delay: animateDelay - animateDelay * 0.2,
      complete: () => {
        done();
        $(el).remove();
      },
    });
}

function after_leave(el) {}

export default {
  before_enter,
  enter,
  after_enter,
  before_leave,
  leave,
  after_leave,
};
